/**
 * langUrl.js — Centralized language ↔ URL slug mapping.
 *
 * Internal lang codes follow BCP-47: "en", "ja", "zh-TW"
 * URL path slugs are lowercase:       "en", "ja", "zh-tw"
 *
 * This module is the single source of truth for:
 *   - Converting between internal lang codes and URL slugs
 *   - Generating language-prefixed URL paths
 *   - The canonical base URL
 */

export const BASE_URL = "https://www.dc-ac.com";

// All supported internal language codes
export const SUPPORTED_LANGS = ["en", "ja", "zh-TW"];

// Internal lang code → URL path slug
const LANG_TO_SLUG = {
  en: "en",
  ja: "ja",
  "zh-TW": "zh-tw",
};

// URL path slug → Internal lang code
const SLUG_TO_LANG = {
  en: "en",
  ja: "ja",
  "zh-tw": "zh-TW",
  zh: "zh-TW", // legacy shorthand
};

/**
 * Convert an internal lang code to a URL slug.
 * e.g. "zh-TW" → "zh-tw", "en" → "en"
 */
export function langToSlug(internalLang) {
  return LANG_TO_SLUG[internalLang] || internalLang.toLowerCase();
}

/**
 * Convert a URL slug (from route params) to an internal lang code.
 * e.g. "zh-tw" → "zh-TW", "zh" → "zh-TW", "en" → "en"
 * Returns null if the slug is not recognized.
 */
export function slugToLang(slug) {
  if (!slug) return null;
  return SLUG_TO_LANG[slug.toLowerCase()] || null;
}

/**
 * Get the URL path prefix for a given internal language code.
 * Always returns a prefix (including for English).
 * e.g. "en" → "/en", "ja" → "/ja", "zh-TW" → "/zh-tw"
 */
export function getLangPrefix(internalLang) {
  const slug = langToSlug(internalLang || "en");
  return `/${slug}`;
}
